export default "__VITE_ASSET__f1e4054b__"